export enum BusinessDataFieldType {
    Text = 'Text',
    MultilineText = 'MultilineText',
    Bool = 'Bool'
}

export interface BusinessDataFieldDto {
    id: string;
    businessId: string;
    code: string;
    name: string;
    description?: string;
    type: BusinessDataFieldType;
    displayOrder: number;
    createdAt: string;
    updatedAt: string;
}

export interface CreateBusinessDataFieldDto {
    code: string;
    name: string;
    description?: string;
    type: BusinessDataFieldType;
    displayOrder: number;
}

export interface UpdateBusinessDataFieldDto {
    code: string;
    name: string;
    description?: string;
    type: BusinessDataFieldType;
    displayOrder: number;
}

export interface UserDataFieldDto {
    id: string;
    userId: string;
    businessDataFieldId: string;
    value: string;
    createdAt: string;
    updatedAt: string;
    businessDataField: BusinessDataFieldDto;
}

export interface UpdateUserDataFieldDto {
    value: string;
}
